import { Modal, Form, IFormContext } from 'rewire-ui';
import authService, { AuthFlow, isOAUTH2Flow } from '../services/AuthService';
import { notifications } from '../ui/Notifications';

interface ILoginState {
  authenticationFlow: AuthFlow;
  forceUsernamePassword: boolean;
}

export class LoginModel extends Modal<ILoginState> {
  form: Form;

  constructor() {
    super('', true);
    this.form = Form.create(
      (form: IFormContext) => ({
        email: form
          .email()
          .label('Email')
          .validators('required')
          .placeholder('enter your email')
          .onValueChange(this.emailChanged)
          .autoFocus(),
        password: form.string().label('Password').validators('required').placeholder('enter your password'),
      }),
      {},
      { updateOnChange: true, validateOnUpdate: true },
    );
    this.state.authenticationFlow = 'UNKNOWN';
    // this.action('sign in', this.submit, { type: 'submit', disabled: () => this.form.hasErrors });
  }

  reset() {
    this.form.reset();
    this.authenticationFlow = 'UNKNOWN';
  }

  get authenticationFlow() {
    return this.state.authenticationFlow;
  }

  set authenticationFlow(authenticationFlow: AuthFlow) {
    this.state.authenticationFlow = authenticationFlow;
    this.form.field.password.visible = this.authenticationFlow === 'USER_PASSWORD';
  }

  emailChanged = () => {
    this.authenticationFlow = 'UNKNOWN';
    this.form.field.password.value = '';
  };

  getAuthenticationFlowForEmail = async (ref: HTMLDivElement) => {
    if (!this.form.field.email.value || this.form.field.email.error) {
      notifications.warning('Please enter your email address');
      return;
    }
    const authenticationFlow = await authService.getAuthenticationFlowForEmail(this.form.field.email.value);
    this.authenticationFlow = authenticationFlow;
    if (authenticationFlow === 'USER_PASSWORD') {
      if (ref) {
        ref.querySelector('input')?.focus();
      }
    }

    if (isOAUTH2Flow(authenticationFlow)) {
      window.location.replace(authenticationFlow.redirectUrl);
    }
  };

  load() {
    this.reset();
  }

  private _login = async (): Promise<boolean> => {
    const email = this.form.field.email.value;
    const password = this.form.field.password.value;
    const authenticated = await authService.authenticate(email, password);
    if (!authenticated) {
      notifications.warning('Invalid username or password');
    }
    return authenticated;
  };

  login = async (): Promise<boolean> => {
    return await this.form.submitAsync(this._login);
  };
}

const loginModel = new LoginModel();
export default loginModel;
